function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.adconst0{fill:#1882A3;}\n\t.adconst1{fill:#006099;}\n\t.adconst2{fill:#006196;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "adconst0",
  d: "M78,13.8h3.4c9.4,0,16,5.6,16,15.7c0,10.9-7.4,15.7-16.1,15.7H78V13.8z M63.4,57.5H84 c15.5,0,28.4-12.2,28.4-28c0-15.7-12.8-28-28.4-28H63.4V57.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "adconst0",
  d: "M35.4,36.6H23.3l6-17.8h0.1L35.4,36.6z M39.3,47.8l3.6,9.7h15.5l-21.1-56H21.5L0,57.5h15.4l3.9-9.7H39.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "adconst0",
  points: "227.5,57.5 242.1,57.5 242.1,23.2 242.2,23.2 268.9,57.5 283.5,57.5 283.5,1.5 268.9,1.5  268.9,35.7 268.8,35.7 242.1,1.5 227.5,1.5  "
}))), /*#__PURE__*/React.createElement("path", {
  className: "adconst0",
  d: "M159.1,39.2c-2.8,3.3-7,5.4-11.6,5.4c-8.4,0-15.2-6.8-15.2-15.2s6.8-15.2,15.2-15.2c4.7,0,8.8,2.1,11.6,5.4 c1.4-4.9,3.8-9.3,7-13.1C161,2.5,154.5,0,147.5,0C131.2,0,118,13.2,118,29.5c0,16.3,13.2,29.5,29.5,29.5c7.1,0,13.6-2.5,18.6-6.6 C162.9,48.5,160.5,44.1,159.1,39.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "adconst1",
  d: "M164.7,29.5c0-0.4,0-0.8,0-1.2h-9.4c-0.6-3.9-3.9-6.8-7.9-6.8c-4.4,0-8,3.6-8,8s3.6,8,8,8c4,0,7.3-3,7.9-6.8 h9.4C164.8,30.3,164.7,29.9,164.7,29.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "adconst2",
  d: "M193.1,1.1c-15.3,0-27.7,12.1-28.3,27.2h20.4c0.6-3.9,3.9-6.8,7.9-6.8c4.4,0,8,3.6,8,8s-3.6,8-8,8 c-4,0-7.3-3-7.9-6.8h-20.4c0.6,15.1,13.1,27.1,28.3,27.1c15.7,0,28.3-12.7,28.3-28.3S208.7,1.1,193.1,1.1z"
})));

function SvgAdconLogoRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Adcon_Logo_4C",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 58.9",
    style: {
      enableBackground: "new 0 0 283.5 58.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdconLogoRgb);
export default __webpack_public_path__ + "static/media/ADCON_Logo_RGB.c67f80a0.svg";
export { ForwardRef as ReactComponent };